import { Box, Divider, Typography, alpha, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { CabecalhoSecao, SecaoPaper, TextosCabecalho } from "./styles";

interface SecaoConfiguracaoProps {
    titulo: string;
    descricao?: ReactNode;
    icone?: ReactNode;
    corIcone?: string;
    acoes?: ReactNode;
    children?: ReactNode;
    semDivisor?: boolean;
}

/**
 * Card padrão das seções de configuração do marketplace:
 * ícone + título + descrição à esquerda e ações à direita.
 */
export const SecaoConfiguracao = ({
    titulo,
    descricao,
    icone,
    corIcone,
    acoes,
    children,
    semDivisor
}: SecaoConfiguracaoProps) => {
    const theme = useTheme();
    const cor = corIcone ?? theme.palette.primary.main;

    return (
        <SecaoPaper elevation={0}>
            <CabecalhoSecao>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                    {icone && (
                        <Box
                            sx={{
                                width: 42,
                                height: 42,
                                flexShrink: 0,
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: cor,
                                backgroundColor: alpha(cor, 0.12),
                                "& svg": { fontSize: "1.35rem" }
                            }}
                        >
                            {icone}
                        </Box>
                    )}
                    <TextosCabecalho>
                        <Typography variant="subtitle1" fontWeight={600} lineHeight={1.35}>
                            {titulo}
                        </Typography>
                        {descricao && (
                            <Typography variant="body2" color="text.secondary">
                                {descricao}
                            </Typography>
                        )}
                    </TextosCabecalho>
                </Box>
                {acoes && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0, flexWrap: "wrap" }}>
                        {acoes}
                    </Box>
                )}
            </CabecalhoSecao>
            {children && (
                <>
                    {!semDivisor && <Divider sx={{ mt: 2 }} />}
                    <Box sx={{ mt: 2, display: "flex", flexDirection: "column", flex: 1 }}>
                        {children}
                    </Box>
                </>
            )}
        </SecaoPaper>
    );
}
